// Documentos fiscais liberados pelo Admin Master (NFC-e, NF-e, NFS-e). A trava de verdade é no servidor;
// aqui só avisamos antes, para o usuário não preencher uma nota que não vai poder emitir.
import React, { useEffect, useState } from "react";
import { fiscal } from "../api";
import { Aviso } from "./ui";

export function useDocumentos() {
  const [d, setD] = useState(null); // sem memória entre telas: depois de trocar de loja nunca vale a regra da loja anterior
  useEffect(() => {
    let vivo = true;
    // erro: fica {} (nenhum tipo confirmado) para as telas saírem do "carregando" sem liberar nada
    fiscal.documentos().then((r) => { if (vivo) setD(r); }).catch(() => { if (vivo) setD((x) => x || {}); });
    return () => { vivo = false; };
  }, []);
  return d;
}

export function AvisoDocumentoBloqueado({ tipo }) {
  const d = useDocumentos();
  if (!d || d[tipo]?.liberado !== false) return null;
  return (
    <div className="mb-4" data-testid={`fiscal-bloqueado-${tipo}`}>
      <Aviso tipo="atencao">A emissão de {d[tipo].nome} ainda não está liberada no sistema. Você pode consultar, imprimir e
        cancelar as notas já emitidas. Para liberar, fale com o suporte da FSC Sistemas.</Aviso>
    </div>
  );
}
